import { formatFilters } from "PFApp/use_filtered_collection";
import api from "PFCore/api";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { RequiresApproval } from "PFTypes";

export const getThresholds = (kind) => {
  const url = ApiRoute(`/api/admin/booking_module/thresholds?kind=${kind}`);
  // @ts-ignore
  return $.ajax({
    url,
    api_version: 2
  });
};

export const saveThresholds = (payload: {
  kind: string;
  thresholds: { min: number | null; max: number | null; color: string }[];
}) => {
  const url = ApiRoute(`/api/admin/booking_module/thresholds`);
  // @ts-ignore
  return $.ajax({
    url,
    api_version: 2,
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify(payload)
  });
};

export const getProfileCalendars = (calendarId, filters, page = 1, perPage = 20) => {
  const searchParams = new URLSearchParams(calendarId ? { calendar_id: calendarId } : "");

  return fetchPaginatedCollection(
    ApiRoute(`/api/admin/booking_module/profile_calendars?${searchParams.toString()}`),
    {
      page,
      perPage,
      filters: formatFilters(filters)
    }
  );
};

export const getProfiles = () => {
  const url = ApiRoute(`/api/admin/profiles`);
  // @ts-ignore
  return $.ajax({
    url,
    api_version: 2
  });
};

export const addProfileToCalendar = (payload: {
  calendarId: string;
  profileId: string;
  startDate: string;
}) => {
  const url = ApiRoute(`/api/admin/booking_module/profile_calendars`);
  // @ts-ignore
  return $.ajax({
    url,
    api_version: 2,
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify({
      calendar_id: payload.calendarId,
      profile_id: payload.profileId,
      start_date: payload.startDate
    })
  });
};
export const removeProfileFromCalendar = ({
  recordId,
  profileId
}: {
  recordId: string;
  profileId: string;
}) => {
  const searchParams = new URLSearchParams({ profile_id: profileId });

  const url = ApiRoute(`/api/admin/booking_module/profile_calendars/${recordId}?${searchParams.toString()}`);
  // @ts-ignore
  return $.ajax({
    url,
    api_version: 2,
    method: "DELETE"
  });
};

type SystemDefinedData = {
  color: string;
  main: boolean;
  requiresApproval: RequiresApproval;
  hidden: boolean;
};

type UserDefinedData = SystemDefinedData & {
  key: string;
  displayAs: string | null;
  archived: boolean;
  billable: boolean;
  affectsAvailability: boolean;
};

type BookingCategoryData = SystemDefinedData | UserDefinedData;

export const createBookingCategory = (data: BookingCategoryData): Promise<void> =>
  api({
    url: "admin/booking_module/booking_categories",
    method: "POST",
    data
  });

export const updateBookingCategory = (categoryId: number, data: BookingCategoryData): Promise<void> =>
  api({
    url: `admin/booking_module/booking_categories/${categoryId}`,
    method: "PUT",
    data
  });
